export default __webpack_public_path__ + "static/media/pic-7.e52ecd70.jpg";